import * as agenda from './agenda';

export default ({
  agenda,
});
